import React from "react";

export default function NotFound() {
  return <div>Some issue happened. Please try again.</div>;
}
